export default [
  {
    "damage": {
      "Vertragsnummer": "999999",
      "Schadennummer": "66666X12",
      "Ereignisdatum": "  .10.2010",
      "Meldedatum": ".05.2012",
      "Deckungszusage": "erteilt",
      "erledigt": "Nein",
      "Kosten": "402.82",
      "VertragsTyp": "P"
    },
    "contract": {
      "Vertragsnummer": "999999",
      "Beginn": "01.03.2008",
      "Ende": "00.01.1900",
      "Selbstbehalt": "1500",
      "Beitrag": "161.39",
      "Produkt": "Einfach: sicher Privat-Rechtsschutz für Nichtselbständige",
      "Tarif": "Normaltarif Mehrpersonenhaushalt EXPERT",
      "Status": "aktiv",
      "Deckungssumme": "350000",
      "Name": "Hermann",
      "Vorname": "Hermann",
      "Strasse": "Aachener Straße 44",
      "PLZ": "67678",
      "Ort": "Bremen",
      "Geburtsdatum": "06.06.1963",
      "Mitversicherte": "Heinrich Böll",
      "Kontostand": "0.00",
      "Mahnstatus": "0",
      "Zahlungsweise": "Bankeinzug monatlich",
      "vereinnahmt": "99.82",
      "offen": "0.00",
      "ProvisionKumuliert": "223.57",
      "ProvisionAktuell": "118.34",
      "Schadenquote": "0.64",
      "Webvorgang": "0",
      "LangeVertragsnummer": "02-01006-999999/03",
      "VertragsTyp": "0",
      "Schaeden": "1"
    }
  }
];